import React from 'react'

const PrivacyPolicy = () => {
    return (
        <>
            <div className='container'>
                <h1 className='' style={{ textAlign: "center", marginTop:"100px" }}> Privacy Policy</h1>

                <p> <b>Introduction</b><br /> At Greenville Projects Pvt Ltd, your privacy is our priority. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you interact with our website, digital campaigns, and services. By using our website, you agree to the practices described in this policy.</p>
                <p> <b>Information We Collect</b><br />We may collect personal and technical data, including but not limited to: </p>

                <p>
                    → Full Name.<br />
                    → Phone Number <br />
                    → Email Address <br />
                    → Location or Property Interests <br />
                    → IP Address & Device Info <br />
                    → Browsing behavior on our site <br />
                  <p>This information is collected when you voluntarily fill out contact forms, interact with our ads, or browse our website.</p>
                </p>
                <br />
                <p><b>Digital Marketing & Tracking</b><br /> </p>
                <p> We use third-party advertising tools like Meta Pixel (Facebook & Instagram Ads) and Google Analytics to understand user behavior and deliver personalized ads. These tools may collect:<br /></p>
                <p>
                    → Pages you view<br />
                    → Time spent on site <br />
                    → Your interactions with ads <br />
                    → Device and location data <br />
                  <p>These insights help us deliver more relevant real estate offerings and improve your overall experience.</p>
                </p>


                <br />
                <p><b>How We Use Your Information</b><br /> </p>
                <p> Your data may be used to:<br /></p>
                <p>
                    → Respond to your property inquiries<br />
                    → Share updates on our projects and offers <br />
                    → Improve website performance and ad relevance <br />
                    → Provide customer support <br />
                    → Send communication via email, SMS, or WhatsApp (only if you opt-in or reach out to us)<br />
                </p>
                <br />
                <p><b>Data Sharing & Security</b><br /> </p>
                <p> We do not sell your personal data to third parties.<br /></p>
                <p>
                    → We may share limited information with trusted service providers (e.g., marketing tools or CRM software) strictly for business purposes<br />
                    → All data is stored securely with appropriate technical and organizational measures<br />
                  
                </p>
                <br />
                <p><b>Cookies & User Tracking</b><br /> </p>
                <p> Our site uses cookies and tracking technologies to enhance user experience, analyze traffic, and run ad campaigns. You can manage or disable cookies through your browser settings.<br /></p>
              
                <br />
                <p><b>Your Choices & Rights</b><br /> </p>
                <p> You have the right to:<br /></p>
                <p>
                    → Access or update your personal information<br />
                    → Opt out of marketing communications<br />
                    → Request deletion of your data<br />
                    → Manage ad preferences via Facebook Ad Settings<br />
                    <p>To exercise your rights, contact us at munirajgreenville@gmail.com.</p>
                  
                </p>
                <br />
                <p><b>External Links</b><br /> </p>
                <p> Our website may contain links to third-party sites. We are not responsible for their privacy practices. Please review their respective privacy policies when visiting.<br /></p>
                <br />
                <p><b>Updates to This Policy</b><br /> </p>
                <p> This policy may be updated periodically. Any changes will be reflected on this page with an updated effective date. We encourage users to review this policy regularly.<br /></p>
                
                <br />
                <p><b>Contact Us</b><br /> </p>
                <p> For any questions regarding this Privacy Policy or your personal data, feel free to contact us:<br /></p>
                <p>
                <br />
                    <b>Greenville Projects Pvt. Ltd.</b><br />
                    → Admin Manager : Naveen<br />
                    → Email: info@greenvilleprojects.com<br />
                    → Phone: +91 9491947397.<br />
                  
                </p>
                <p>
                </p>
            </div>
            <br /><br /><br />

        </>
    )
}

export default PrivacyPolicy